import { Action, createReducer, on } from '@ngrx/store';
import { PermWizardActions } from '../actions';
import { PermWizardStates } from '../states';
import { permWizardAdapters, initialState } from '../states/permission-wizard.states';

export const permWizardReducer = createReducer(
    initialState,

    on(PermWizardActions.createPermWizardSuccess, (state, action) => ({...state, updatePermWizardListing: true})),
    on(PermWizardActions.createPermWizardFailure, (state, action) => 
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // update perm set
    on(PermWizardActions.updatePermWizardSuccess, (state, action) => ({...state, updatePermWizardListing: true})),
    on(PermWizardActions.updatePermWizardFailure, (state, action) => 
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // update perm assignee target links
    on(PermWizardActions.updatePermAssigneeTargetLinksFailure, (state, action) => 
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // delete perm set
    on(PermWizardActions.deletePermWizardSuccess, (state, action) => ({...state, updatePermWizardListing: true})),
    on(PermWizardActions.deletePermWizardFailure, (state, action) => 
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // delete perm assignee target links
    on(PermWizardActions.deletePermAssigneeTargetLinksFailure, (state, action) => 
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    on(PermWizardActions.setNewPermWizard, (state, action) => ({...state, newPermWizard: action.permWizard})),
    on(PermWizardActions.selectPermWizard, (state, action) => ({...state, selectedPermWizard: action.permWizard})),
    on(PermWizardActions.setPermTemplate, (state, action) => ({...state, selectedPermTemplate: action.permTemplate})),
    on(PermWizardActions.selectPermWizardLine, (state, action) => ({...state, selectedPermWizardLine: action.permWizardLine})),
    // on(PermWizardActions.setPermWizardLineChanges, (state, action) => ({...state, permWizardLineChanges: action.lineChanges})),

    on(PermWizardActions.setUpdatePermWizardListing, (state, action) => ({...state, updatePermWizardListing: action.update})),

    on(PermWizardActions.selectGuid, (state, action) => ({...state, selectedGuid: action.guid})),
    on(PermWizardActions.setRequiresUpdate, (state, action) => ({...state, requiresUpdate: action.update})),

    on(PermWizardActions.saveViewState, (state, action) => ({...state, viewCache: action.cache}))
)

export function perm_wizard_reducer(state: PermWizardStates | undefined, action: Action) {
    return permWizardReducer(state.permWizard, action);
}